var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGuardian = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5453 2.65469L6.23594 0.845312C6.17187 0.823437 6.08594 0.8125 6 0.8125C5.91406 0.8125 5.82812 0.823437 5.76406 0.845312L0.454688 2.65469C0.325 2.69844 0.21875 2.84844 0.21875 2.98594V10.5234C0.21875 10.6609 0.307813 10.8422 0.415625 10.9281L5.80156 15.125C5.85625 15.1672 5.92656 15.1891 5.99844 15.1891C6.07031 15.1891 6.14219 15.1672 6.19531 15.125L11.5813 10.9281C11.6891 10.8438 11.7781 10.6625 11.7781 10.5234V2.98594C11.7812 2.84844 11.675 2.7 11.5453 2.65469ZM8.85156 5.32344L5.52969 9.89687C5.50633 9.92884 5.47577 9.95484 5.44047 9.97276C5.40518 9.99069 5.36615 10 5.32656 10C5.28698 10 5.24795 9.99069 5.21265 9.97276C5.17736 9.95484 5.14679 9.92884 5.12344 9.89687L3.14844 7.17812C3.08906 7.09531 3.14844 6.97969 3.25 6.97969H4.1125C4.19219 6.97969 4.26875 7.01875 4.31563 7.08281L5.32656 8.47344L7.68437 5.22656C7.73125 5.1625 7.80625 5.12344 7.8875 5.12344H8.75C8.85156 5.125 8.91094 5.24062 8.85156 5.32344Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGuardian, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/guardian.34851833.svg";
export { ForwardRef as ReactComponent };